module.exports = __webpack_public_path__ + "img/cliente-4.374c7404.jpg";